<template>
  <artmisads-modal
    title="Edit Receive Record"
    :open.sync="visible"
    width="500px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="true"
    :onCancel="handleCancel"
  >
    <div class="form">
         <a-form
          :model="formState"

          ref="editFormRef"
          name="basic"
          :label-col="{ span: 24 }"
          :wrapper-col="{ span: 24 }"
          autocomplete="off"
        >
            <a-form-item
            label="Received Amount"
            name="confirmPaidAmount"
            :rules="[{ required: true, message: 'Please input Received Amount!' }]" 
          >
            <a-input-number style="width: 100%;" id="inputNumber" v-model:value="formState.confirmPaidAmount" :min="1" :max="9999" />
          </a-form-item>
          <a-form-item
            label="Received Time"
            name="bankReceivedTime"
            :rules="[{ required: true, message: 'Please input Received Time!' }]" 
          >
            <a-date-picker style="width: 100%;" show-time v-model:value="formState.bankReceivedTime" type="date" format="YYYY-MM-DD HH:mm:ss" />
          </a-form-item>
        </a-form>
    </div>
    <template #footer>
      <artmisads-button @click="handleCancel">Cancel</artmisads-button>
      <artmisads-button type="primary" @click="handleOk">Submit</artmisads-button>
    </template>
  </artmisads-modal>
</template>
<script setup lang="jsx">
import { ref,defineExpose,defineEmits,nextTick } from 'vue'
import { financeApi } from "~/server/operator/finance";
import { useUserInfoStore } from "@/storeData";
import { COUNTRY_TIME_TZ } from '~/contants/common'
const emit = defineEmits(['refresh'])

  const user = useUserInfoStore();
import moment from 'moment'
import { message } from 'ant-design-vue'
 const timeZone = () => {
    const countryCode = user?.userInfo?.countryCode || 'US';
    const data = COUNTRY_TIME_TZ[countryCode];
    return data;
  }
const formState=ref({
  bankReceivedTime: '',
  confirmPaidAmount:null
})
const billingId=ref('')
const editFormRef=ref(null)
const visible = ref(false)
const openModal = (record) => {
  visible.value = true
  billingId.value=record.billingId
  nextTick(()=>{
    formState.value={
      bankReceivedTime: '',
      confirmPaidAmount: ''
    }
    editFormRef.value.resetFields()
  })
}
const handleCancel=()=>{
  visible.value=false
}
const handleOk = async () => {
 
   editFormRef.value.validate().then((valid) => {
    const data={
      billingId: billingId.value,
      confirmPaidAmount: formState.value.confirmPaidAmount,
      bankReceivedTime: moment(formState.value.bankReceivedTime).tz(timeZone()).format('YYYY-MM-DD HH:mm:ss')
    }
    
    financeApi.setReceivedDetails(data).then((res) => {
      if(res.success){
        message.success('Edit Receive Record Success');
        visible.value = false;
        emit('refresh')
      }else{

        message.error(res.error );
      }
    })
  })
}
const handleExport=()=>{
  
}
defineExpose({
  openModal
})
</script>